import React, { useState, useEffect } from 'react';
import apiClient from '../../Api/axiosConfig';

const ImageBrowserModal = ({ onSelect, onClose }) => {
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [uploading, setUploading] = useState(false);

  const fetchImages = () => {
    setIsLoading(true);
    apiClient.get('/file/list/images')
      .then(response => {
        setImages(response.data);
      })
      .catch(() => setError('Hiba a képek betöltésekor.'))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchImages();
  }, []);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);
    
    setUploading(true);
    setError('');
    try {
      const response = await apiClient.post('/file/upload/images', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      // Sikeres feltöltés után azonnal frissítjük a galériát
      fetchImages();
    } catch (err) {
      setError(err.response?.data?.message || 'Feltöltési hiba.');
    } finally {
      setUploading(false);
      e.target.value = null; // Reseteli az inputot
    }
  };
  
  const handleDelete = async (imagePath, e) => {
    e.stopPropagation(); // Megakadályozza, hogy a kép kiválasztása is megtörténjen
    if (!window.confirm(`Biztosan törölni szeretnéd a(z) "${imagePath}" fájlt?`)) {
      return;
    }
    
    try {
      await apiClient.post('/file/delete', { path: imagePath });
      fetchImages(); // Törlés után frissítünk
    } catch (err) {
      setError(err.response?.data?.message || 'Törlési hiba.');
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Képek tallózása</h2>
          <button onClick={onClose} className="close-button">&times;</button>
        </div>
        <div className="modal-body">
          <div className="image-gallery">
            {isLoading && <p>Töltés...</p>}
            {images.map(image => (
              <div key={image} className="gallery-item" onClick={() => onSelect(image)}>
                <img src={image} alt={image} />
                <button className="delete-image-button" onClick={(e) => handleDelete(image, e)}>🗑️</button>
              </div>
            ))}
          </div>
        </div>
        <div className="modal-footer">
          <label className={`upload-button ${uploading ? 'disabled' : ''}`}>
            {uploading ? 'Feltöltés...' : 'Új kép feltöltése'}
            <input type="file" onChange={handleFileChange} disabled={uploading} accept="image/*" />
          </label>
          {error && <p className="modal-error">{error}</p>}
        </div>
      </div>
    </div>
  );
};

export default ImageBrowserModal;